/* eslint-disable max-len */
import { useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from './button'
import FormState from '../model/FormState'

export default function FormStep1(
    props: {setTab: any, formState: FormState, set: any}
) {
    const { setTab, formState, set } = props
    const form = useRef<HTMLFormElement>(null)
    const history = useHistory()

    const onSubmit = (event: any) => {
        event.preventDefault()
        if (form?.current?.checkValidity() !== false) {
            setTab(2)
        }
        form?.current?.classList.add('was-validated')
    }

    const cancelar = () => {
        history.push('/buscar')
    }

    return (
        <form noValidate onSubmit={onSubmit} ref={form}>
            <div className="form-row">
                <div className="col-md-4 mb-3">
                    <label htmlFor="inputNome">Nome</label>
                    <input
                        type="text"
                        className="form-control"
                        id="inputNome"
                        placeholder="Nome"
                        value={formState.nome}
                        onChange={(e) => {set('setNome', e.target.value)}}
                        required
                        minLength={3}
                        maxLength={60}
                    />
                    <div className="invalid-feedback">
                        Informe um nome com no mínimo 3 caracteres
                    </div>
                </div>
                <div className="col-md-3 mb-3">
                    <label htmlFor="inputTelefone">Telefone</label>
                    <input
                        type="text"
                        className="form-control"
                        id="inputTelefone"
                        placeholder="Telefone"
                        value={formState.telefone}
                        onChange={(e) => {set('setTelefone', e.target.value)}}
                        required
                        maxLength={20}
                        minLength={8}
                        pattern="^\(?\d{2}\)?[\s-]?[\s9]?\d{4,5}-?\d{4}$"
                    />
                    <div className="invalid-feedback">
                        Informe um telefone válido
                    </div>
                </div>
                <div className="col-md-5 mb-3">
                    <label htmlFor="inputEmail">Email</label>
                    <input
                        type="email"
                        className="form-control"
                        id="inputEmail"
                        placeholder="Email"
                        value={formState.email}
                        onChange={(e) => {set('setEmail', e.target.value)}}
                        required
                        minLength={10}
                        pattern="^[^@]+@[^@]+\.[^@]+$"
                    />
                    <div className="invalid-feedback">
                        Informe um email válido
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="inputSite">Site</label>
                    <input
                        type="text"
                        className="form-control"
                        id="inputSite"
                        placeholder="Endereço Web"
                        value={formState.site}
                        onChange={(e) => {set('setSite', e.target.value)}}
                        required
                        pattern="^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
                    />
                    <div className="invalid-feedback">
                        Informe uma url válida
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="inputPitch">
                        Pitch
                    </label>
                    <input
                        type="url"
                        className="form-control"
                        id="inputPitch"
                        placeholder="Endereço Web"
                        value={formState.pitch}
                        onChange={(e) => {set('setPitch', e.target.value)}}
                        required
                        pattern="^(http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
                    />
                    <div className="invalid-feedback">
                        Informe uma url válida
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-12 mb-3">
                    <label htmlFor="inputDescricao">
                        Descrição
                    </label>
                    <textarea
                        className="form-control"
                        id="inputDescricao"
                        rows={3}
                        value={formState.descricao}
                        onChange={(e) => {
                            set('setDescricao', e.target.value)
                        }}
                        required
                        minLength={1}
                    />
                    <div className="invalid-feedback">
                        Informe uma descrição
                    </div>
                </div>
            </div>
            <div className="form-row justify-content-end mt-2">
                <button type="button" onClick={cancelar} className="btn mr-2">Cancelar</button>
                <Button type="submit" className="ml-2" autoFocus>
                    Próximo
                    <i className="fas fa-chevron-right fa-sm ml-2" />
                </Button>
            </div>
        </form>
    )
}
